import * as React from 'react'
import { Modal, ModalProps } from 'components/common'

export interface LedgerCancelModalProps extends Omit<ModalProps, 'onOk'> {
  name: string | number
  onOk: () => void
}

export const LedgerCancelModal = ({
  name,
  onOk,
  ...rest
}: LedgerCancelModalProps) => (
  <Modal
    title={`No.${name}の赤伝を切る`}
    cancelText="キャンセル"
    onOk={onOk}
    okText="赤伝を切る"
    okButtonProps={{ type: 'primary' }}
    {...rest}
  >
    <div>赤伝を切り、No.{name}の処理を取り消しますか？</div>
    <div>この操作は取り消すことができません。</div>
  </Modal>
)
